import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function PatientPrivacyNoticePage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-3374" data-mp="2v32elr03poen">
      <section className="bg-teal-900 text-white py-16" data-id="element-3375" data-mp="2v3ua71tp7m4x">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3376" data-mp="2q2n1n0jqeix7">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-3377" data-mp="342xta5sv81jf">
            Patient Privacy Notice
          </h1>
          <p className="text-teal-100" data-id="element-3378" data-mp="301m4u3lq9mct">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-3379" data-mp="3dtacnuoy1onz">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3380" data-mp="3ds92rtjnz87u">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-3381" data-mp="38te9fxo2m19h">
            <p className="lead" data-id="element-3382" data-mp="3nqy9cq64168s">
              Dentico Dental Clinic Ltd is responsible for your personal data.
            </p>

            <h3 data-id="element-3383" data-mp="3ismzifftevqk">
              When you request an appointment or become our patient, we may
              collect:
            </h3>
            <ul data-id="element-3384" data-mp="2aubbqn8qb7v5">
              <li data-id="element-3385" data-mp="2autabqiv5y68">contact details,</li>
              <li data-id="element-3386" data-mp="2frbhsy5kwam9">appointment and administrative details,</li>
              <li data-id="element-3387" data-mp="2fto6rv9r7l8t">
                relevant health information needed to provide safe dental care.
              </li>
            </ul>

            <h3 data-id="element-3388" data-mp="2ot179yfwgzhe">We use your data to:</h3>
            <ul data-id="element-3389" data-mp="2ou2q4p35qq9o">
              <li data-id="element-3390" data-mp="2oqf1o4ckku1t">provide dental care and manage appointments,</li>
              <li data-id="element-3391" data-mp="2tqt9bla9e1zb">communicate about treatment and follow-up,</li>
              <li data-id="element-3392" data-mp="2yq5tfy9qwuy7">
                comply with legal, regulatory, and professional obligations.
              </li>
            </ul>

            <h3 data-id="element-3393" data-mp="33ip5gqssbi0w">Data Sharing</h3>
            <p data-id="element-3394" data-mp="33jifc0n1inn9">
              We do not sell your data. We may share data with trusted providers
              (e.g. booking/IT systems, laboratories, advisers) where necessary
              and lawful.
            </p>

            <h3 data-id="element-3395" data-mp="3hgxbrpbpnvoq">Your Rights</h3>
            <p data-id="element-3396" data-mp="3hi8fjp55p3fu">
              You have data protection rights under UK law, including access,
              correction, objection/restriction, and withdrawal of consent where
              consent is used.
            </p>

            <div className="bg-teal-50 p-6 rounded-xl mt-8 not-prose" data-id="element-3397" data-mp="1chfi1wnzbh2f">
              <h3 className="text-lg font-bold text-teal-900 mb-4" data-id="element-3398" data-mp="1r5sfky2pt7z1">
                Contact Us
              </h3>
              <div className="space-y-2 text-teal-800" data-id="element-3399" data-mp="1md8r362hosfg">
                <p data-id="element-3400" data-mp="2055e4vpawc4z">
                  <strong data-id="element-3401" data-mp="204nkm6u0wc0r">Email:</strong>{' '}
                  <a href="mailto:info@denticoclinic.co.uk" className="hover:underline" data-id="element-3402" data-mp="207i703wlk6wt">
                    info@denticoclinic.co.uk
                  </a>
                </p>
                <p data-id="element-3403" data-mp="254rtpbslq4gy">
                  <strong data-id="element-3404" data-mp="2548hmbpmuaau">Address:</strong> 360–364 City Road, London EC1V 2PY
                </p>
                <p data-id="element-3405" data-mp="fosf3f67rmtx">
                  <strong data-id="element-3406" data-mp="fqdat849lbtd">Phone:</strong> +44 7345 197820
                </p>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}